import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/styles.css";

const Home = React.lazy(() => import("./Views/Home"));
const Login = React.lazy(() => import("./Views/Login"));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" name="home" element={<Home />} />
        <Route path="/login" name="login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
